<input
  type="text"
  class="form-control"
  placeholder="Search your address"
  #searchAddress
  class="form-control"
/>
